export const GOOGLE_MAPS_LOAD_ERROR_MESSAGE = 'Error loading Google Maps API';
export const POST_PAYMENT_ACTIONS_TIMEOUT_MESSAGE = 'Timeout Error';
export const PAYNOW_COLLECT_PAYMENT_ERROR_MESSAGE = 'There were errors while collecting funds. Please try again later';
